import React from "react"
import Markdown from "@components/Markdown"
import MetaButton from "@components/MetaButton"
import ModuleHeader4 from "@components/ModuleHeader4"
import MetaImage from "@components/MockableImages"
import BackgroundImageHome from "@components/MockableImages/background"

import { useBreakpoints } from "@hooks/useBreakpoints"
export default ({
  theme = "blue-bg",
  full = false,
  reversed = false,
  imageUrl,
  mobileImageUrl,
  tabletImageUrl,
  headerText,
  contentText,
  buttons = [],
  classes = null,
  contentList = [],
  ...props
}) => {
  let background = "",
    color = ""

  const { isTablet, isDesktop, isMobile } = useBreakpoints()
  switch (theme) {
    case "blue-bg":
      background = "bg-dblue"
      color = "text-white"
      break
    case "white-bg":
      background = "bg-white"
      color = "text-dblue"
      break
    case "lblue-bg":
      background = "bg-lblue"
      color = "text-black"
      break
    case "gray-bg":
      background = "bg-lblue"
      color = "text-dblue"
      break
  }

  return (
    <div className={`${background}`}>
      <div
        className={`${
          classes?.topDiv
        } max-w-screen-fhd mx-auto flex flex-wrap  md:py-10 desk:py-25 desk:px-25 md:pl-[44px] ${
          full
            ? reversed
              ? "md:pl-5.1 desk:pl-12.5 pt-10"
              : "md:pr-6 desk:pr-12.5 pt-10"
            : "md:px-6 desk:pr-25 desk:px-25 desk:pb-34 pt-6"
        }`}
        {...props}
      >
        <div
          className={`${
            classes?.divColumnLeft
          } w-full md:w-1/2 flex justify-center ${
            reversed ? "md:order-last" : "order-first"
          }`}
        >
          {!isMobile && !full && (
            <div
              className={` md:h-[100%] mb-[24px] w-full md:mb-0 ${classes?.onlyDivImage}`}
            >
              <BackgroundImageHome
                image={imageUrl}
                classes={classes?.backgroundImageHome}
              />
            </div>
          )}
          {full && isTablet && (
            <div
              className={` md:ml-17 md:overflow-hidden md:h-[353px] md:w-[318px] shadow-custom ${classes?.onlyDivImage}`}
            >
              <MetaImage
                image={imageUrl}
                containerClassName={"custom-gatsby-image "}
              />
            </div>
          )}
          {(isMobile || (full && !isTablet)) && (
            <MetaImage image={imageUrl} classNameImage={classes?.image} />
          )}
        </div>
        <div
          className={`${classes?.divText} w-full md:w-1/2 px-6 ${
            full ? "pt-6 pb-5.1" : "pt-5.1"
          } flex flex-col justify-center ${
            reversed ? "md:pr-3 desk:pr-32" : "md:pl-[74px] desk:pl-[178px] "
          } md:py-10 desk:py-[50px] md:mb-0 desk:pr-0`}
        >
          <div>
            <ModuleHeader4
              theme={theme}
              className={
                (classes?.headerOfTextCol || "") +
                " desk:text-[40px] font-medium"
              }
            >
              {headerText}
            </ModuleHeader4>
            <div
              className={` ${classes?.pContainer} font-inter  leading-150% ${color} opacity-70 text-sm desk:text-20 list-module list-check font-normal`}
            >
              {contentText && Array.isArray(contentText) && (
                <div>
                  {contentText.map((item, index) => (
                    <p
                      key={item.text || item}
                      className={item.class || classes.p}
                    >
                      {item.text ? item.text : <Markdown>{item}</Markdown>}
                    </p>
                  ))}
                </div>
              )}
              {contentText && !Array.isArray(contentText) && (
                <Markdown>{contentText}</Markdown>
              )}
              {contentList && contentList.length > 0 && (
                <ul className={classes.ul}>
                  {contentList.map((item, index) => (
                    <li
                      key={index}
                      className={`${
                        item.className || ""
                      } font-normal text-sm desk:text-20`}
                    >
                      {item.text}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            {buttons.length > 0 &&
              buttons.map(
                (
                  {
                    text,
                    className,
                    fn,
                    theme,
                    dataEventId,
                    inverted,
                    ...rest
                  },
                  index
                ) => (
                  <MetaButton
                    key={text}
                    className={className}
                    onClick={fn}
                    theme={theme}
                    dataEventId={dataEventId}
                    inverted={inverted}
                    {...rest}
                  >
                    {text}
                  </MetaButton>
                )
              )}
          </div>
        </div>
      </div>
    </div>
  )
}
